import React from 'react';
import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import '../../../Styles/LmsExtra.css';
import AdministrarCursosCatalog from './AdministrarCursosCatalog';

export default function AdministrarCursosPage() {
    return <AdministrarCursosCatalog />;
}
